import '../delay_render_chart_view.js.coffee';# Added by Script 
class CustomerVisualMode.Charts.MetricsPerAgentChartView extends CustomerVisualMode.Charts.DelayRenderChartView
  initialize: ({widget, data, title, description, dimensionName, templateTarget, session, isReadOnly, isResponsive}) ->
    @widget = widget
    @widget.set('chart_type', Common.Dashboard.Widget.ChartType.bar)
    @widget.set('sorting', Common.Dashboard.Widget.SortType.descCount)
    @widget.set('show_top_ten', true)
    @widget.set('is_maximized', false)
    @widget.set('use_work_calendar', true)
    @widget.set('widget_name', @constructor.NAME)
    @data = data
    @currentDimension = dimensionName
    @dimensionName = dimensionName
    @templateTarget = templateTarget
    @barMenuView = new Common.Dashboard.Charts.BarMenuViewFactory().create(@widget, @data)
    @barMenuView.chartView = @
    @barMenuView.customOptionViews.map((view) => @listenTo(view, view.toggleEventName, view.getToggleMethod(@)))
    super({widget, description, data, session, isReadOnly, isResponsive})
    @_updateTitle(@_getTitleWithExtraText(@constructor.NAME))

  render: ->
    super()
    @renderBarPlot = @_renderBarPlot()
    @$el.find('.chart').html(@template)
    @sortDropdown = @_createSortDropdown(@widget)
    @listenTo(@renderBarPlot, 'singledimension:click', @_openDrilldown)
    @$el.find(@templateTarget).append(@renderBarPlot.render().el)
    @$el.find('.chart-actions').prepend(@sortDropdown.render().el)
    @$el.find('.chart-actions').children().last().before(@barMenuView.render().el)
    @listenTo(@sortDropdown, 'change', @_changeSorting) if @sortDropdown
    @

  _formatDataToPlot: ->
    nameTranslator = new CustomerVisualMode.UserWidgetDataTranslator()
    valueTranslator = @_workCalendarStrategy(
      new CustomerVisualMode.NullValueTranslator,
      new CustomerVisualMode.WithoutWorkCalendarValueTranslator
    )
    dataFormatter = new CustomerVisualMode.Charts.DataFormatter(nameTranslator, valueTranslator)
    dataFormatter.format(@widget, {data: @data})

  _changeSorting: (sorting) ->
    @widget.set('sorting', sorting)
    @_updateChartData()

  toggleShowQuantity: ->
    @widget.set('show_top_ten', !@widget.get('show_top_ten'))
    @_updateChartData()

  toggleUseWorkCalendar: ->
    @widget.set('use_work_calendar', !@widget.get('use_work_calendar'))
    @currentDimension = @_workCalendarStrategy(@dimensionName, "#{@dimensionName}_no_calendar")
    @_updateChartData()

  toggleMaximize: ->
    @widget.set('is_maximized', !@widget.get('is_maximized'))
    @widget.updateWidget()
    @trigger('masonry')
    @_setChartWidth()

  _setChartWidth: ->
    @renderBarPlot.setChartWidth(@)
    @chart?.reflow()

  _updateChartData: ->
    @_updateTitle(@_getTitleWithExtraText(@constructor.NAME))
    @renderBarPlot.updateData(@_formatDataToPlot())

  _getTitle: (name) ->
    title = I18n.t("customer_visual_mode.charts.#{name}.title") + @._workCalendarStrategy(
      " (#{I18n.t('customer_visual_mode.charts.use_work_calendar')})",
      " (#{I18n.t('customer_visual_mode.charts.not_use_work_calendar')})"
    )

  _getTitleWithExtraText: (name) ->
    extra_text =
    if (@widget.get('show_top_ten'))
    then I18n.t('customer_visual_mode.charts.top_ten') else I18n.t('customer_visual_mode.charts.all_results')

    "#{@_getTitle(name)} (#{extra_text})"

  _renderBarPlot: ->
    new CustomerVisualMode.Charts.BarGraphChartView(
      data: @_formatDataToPlot(),
      maxHeight: 1000,
      dataLabelFormatter: @_formatDataLabel,
      tooltipFormatter: @_formatTooltip
      )

  _renderChart: =>
    @chart = @renderBarPlot.renderChart()
    @_setChartWidth()
    @barMenuView.chart = @chart
    @barMenuView.chartView = @
    @chart

  _openDrilldown: (drilldownValue) =>
    valueName = _.find(@data, (item) -> item.name == drilldownValue).user_name
    drilldownName = "#{@_drilldownTitle()} (#{valueName})"
    data = {
      dimensions: [@currentDimension],
      name:  drilldownName,
      values: [drilldownValue]
      drilldown_code: 'created_conversations',
      timezone: moment().format('Z')
    }
    super(data)

  _drilldownTitle: ->
    'Metrics Per Agent'

  _createSortDropdown: (widget) ->
    new Common.Sessions.SortDropdown(widget.get('sorting'))

  _secondsToIsoFormat: (totalSeconds) ->
    hours = Math.floor(totalSeconds / 3600)
    totalSeconds %= 3600
    minutes = Math.floor(totalSeconds / 60)
    seconds = Math.ceil(totalSeconds % 60)
    #Leading zeroes
    minutes = String(minutes).padStart(2, '0')
    hours = String(hours).padStart(2, '0')
    seconds = String(seconds).padStart(2, '0')
    formattedString = "#{hours}:#{minutes}:#{seconds}"
    return formattedString

  _formatDataLabel: (value) =>
    @_secondsToIsoFormat(value)

  _formatTooltip: (key, value) =>
    "<b>#{key}</b>: #{@_secondsToIsoFormat(value)}"
